import { typo, ActionButton } from '@cycle-app/ui';
import { small } from '@cycle-app/utilities';
import styled from 'styled-components';

import PortalModal from 'src/components/PortalModal/PortalModal';

import { FeaturesList } from '../FeaturesList';

export const StyledActionButton = styled(ActionButton)`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const Container = styled.div`
  display: flex;
  margin-top: 16px;
  gap: 54px;

  /* features */
  > :first-child {
    flex-basis: 50%;
  }

  /* upgrade box cta */
  > :last-child {
    flex-basis: 50%;
    flex-grow: 1;
  }

  ${small} {
    > :first-child {
      display: none;
    }
  }
`;

export const Title = styled.h2`
  ${typo.headerLarge600}
`;

export const StyledPortalModal = styled(PortalModal)`
  width: 935px;
  padding: 48px 48px 65px;
`;

export const StyledFeatures = styled(FeaturesList)`
  margin-top: 24px;
`;

export const RightBox = styled.div`
  border-radius: 12px;
  padding-top: 24px;
  padding-bottom: 24px;
  border: 1px solid ${p => (p.theme.isDark ? p.theme.baseColors.Grey850 : p.theme.baseColors.Grey200)};
`;

export const RightBoxHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  & > :first-child {
    border-right: 1px solid ${p => (p.theme.isDark ? p.theme.baseColors.Grey850 : p.theme.baseColors.Grey200)};
  }
`;

export const RightBoxBody = styled.div`
  margin-top: 24px;
  padding-left: 24px;
  padding-right: 24px;
`;
